import React from 'react';
import style from "./PayrollList.css";
import ButtonModal from "./ButtonModal.jsx";
import {ModalVoucher} from "./Modals.jsx";
import { API_URI } from "../consts";
import { STATUS_LABEL_DETAIL, TEXT_LABEL_SUMMARY} from './../consts';

const RowPayroll = (props) => (
    <tr>
        <td>{props.payroll.recruiter}</td>
        <td>{props.payroll.startPeriod}</td>
        <td>{props.payroll.endPeriod}</td>
        <td style={{textAlign: "center"}}>{props.payroll.generationDate}</td>
        <td style={{textAlign: "center"}}>{props.payroll.createdBy}</td>
        <td style={{textAlign: "right"}}>{props.payroll.totalPartners}</td>
        <td style={{textAlign: "right"}}>{props.payroll.total.toLocaleString("es-CL", {style: "currency", currency: "clp"})}</td>
        <td className={style.PayrollList__tdStatus}>
            <span className={`label ${STATUS_LABEL_DETAIL[props.payroll.status]}`}>
                {TEXT_LABEL_SUMMARY[props.payroll.status]}
            </span>
        </td>
        <td>
            <a className="btn btn-xs btn-success" href={`${API_URI}excel-bank-download?payrollId=${props.payroll.payrollId}&bankId=37`}>
                Santander
            </a>
            <a className="btn btn-xs btn-success" href={`${API_URI}excel-bank-download?payrollId=${props.payroll.payrollId}&bankId=14`}>
                Scotiabank
            </a>
            <ButtonModal
                getPartners={props.getPayrolls}
                btnClassName="btn btn-xs btn-info"
                btnText="Voucher"
                isEnabled={true}
            >
                <ModalVoucher
                    payroll={props.payroll}
                    vouchers={props.payroll.vouchers}
                />
            </ButtonModal>
            <button 
                className="btn btn-xs btn-warning" 
                onClick={() => props.deletePayroll(props.payroll.payrollId)} 
                disabled={props.payroll.status === 2}>
                Eliminar
            </button>
        </td>
    </tr>
);

export default RowPayroll;


// WEBPACK FOOTER //
// ./frontEnd/treasury/payment-partners/components/RowPayroll.jsx